import { TrackingService } from '../../../services/tracking.service';

export class SignupRegistrationRequest
{
    // keeping these here in case we want to offer different tiers going forward.
    readonly siteId = 2;
    readonly subscriptionTemplateId = 3;
    readonly pricingOptionId = 3;

    fullName: string;
    groupName: string;
    email: string;
    phone: string;
    captcha: string;
    password: string;

    tracking: string[];

    constructor(request: any) {
        if (request) {
            if (request.fullName) {
                this.fullName = request.fullName;
            }

            if (request.groupName) {
                this.groupName = request.groupName;
            }

            if (request.email) {
                this.email = request.email;
            }

            if (request.phone) {
                this.phone = request.phone;
            }

            if (request.captcha) {
                this.captcha = request.captcha;
            }

            if (request.password) {
                // TODO: Shouldn't we hash this?
                this.password = request.password;
            }

            this.tracking = [];
            // from local storage or cookies
            if (TrackingService.read()) {
                const tracking = TrackingService.read();
                if (tracking.agent) {
                    this.tracking.push('agent=' + tracking.agent);
                }
                if (tracking.referrer) {
                    this.tracking.push('referrer=' + tracking.referrer);
                }
                if (tracking.target) {
                    this.tracking.push('target=' + tracking.target);
                }
                const queryParams = tracking.queryParams;
                if (queryParams) {
                    Object.keys(queryParams).forEach((key) => {
                        this.tracking.push(key + '=' + queryParams[key]);
                    });
                }

                // hubspot tracking cookie
                if (tracking.hutk) {
                    this.tracking.push('hutk=' + tracking.hutk);
                }
            }
        }
    }
}
